  <template>
  <div id="pagesContainer" v-if="job">
    <div id="desktopJobPage">
      <b-container>
        <b-row>
          <b-col lg="8" id="columnLeft">
            <TitleSection v-bind:job="job"></TitleSection>
            <DescriptionSection v-bind:description="description"></DescriptionSection>
          </b-col>
          <b-col lg="4" id="columnRight">
            <ApplyButtonSection v-bind:job="job"></ApplyButtonSection>
            <JobTableSection v-bind:job="job"></JobTableSection>
            <ContactSection v-if="job.Contact" v-bind:job="job"></ContactSection>
          </b-col>
        </b-row>
        <b-row>
          <p></p>
        </b-row>
        <BackButton></BackButton>
      </b-container>
    </div>
    <div id="mobileJobPage">
      <TitleSection v-bind:job="job"></TitleSection>
      <ApplyButtonSection v-bind:job="job"></ApplyButtonSection>
      <JobTableSection v-bind:job="job"></JobTableSection>
      <DescriptionSection v-bind:description="description"></DescriptionSection>
      <ContactSection v-if="job.Contact != null" v-bind:job="job"></ContactSection>
    </div>
  </div>
</template>

<script>
import JobTableSection from "../components/JobPage/JobTableSection";
import TitleSection from "../components/JobPage/TitleSection";
import DescriptionSection from "../components/JobPage/DescriptionSection";
import ApplyButtonSection from "../components/JobPage/ApplyButtonSection";
import ContactSection from "../components/JobPage/ContactSection";
import BackButton from "../components/JobPage/BackButton";
export default {
  name: "JobPage",
  components: {
    JobTableSection,
    TitleSection,
    DescriptionSection,
    ApplyButtonSection,
    ContactSection,
    BackButton
  },
  data() {
    return {
      job: { Contact: { Image: "" } },
      description: null
    };
  },
  methods: {
    GetContentIdFromUrlSegment(urlSegment) {
      let index = urlSegment.length - 1;
      let charFromUrlSegment = urlSegment[index];
      let charIsNumeric = !isNaN(charFromUrlSegment);
      let protoContentId = "";
      while (charIsNumeric) {
        protoContentId = charFromUrlSegment + protoContentId;
        index -= 1;
        charFromUrlSegment = urlSegment[index];
        charIsNumeric = !isNaN(charFromUrlSegment);
      }
      let contentId = protoContentId;
      return contentId;
    }
  },
  created() {
    let contentId = this.GetContentIdFromUrlSegment(
      this.$route.params.urlSegment
    );
    fetch("/umbraco/api/jobs/GetJobModuleDataSingleJob/" + contentId)
      .then(response => response.json())
      .then(data => {
        // set the title of the page.
        document.title = data.Jobs[0].Title;
        this.job = data.Jobs[0];
        this.$store.commit("mutateMiscData", data.MiscData);
        // this.$store.commit(
        //   "mutateJobouselImagesSingleJob",
        //   data.Jobs[0].Images
        // );
        this.description = data.Jobs[0].Description;
      });
  }
};
</script>

<style>
.white {
  background-color: white;
}
</style>

<style scoped>
/* shared */

#desktopJobPage {
  display: none;
}
#mobileJobPage {
  display: none;
}

#JobTableSection {
  padding-top: 40px;
  margin-bottom: auto, 0;
}

/* > 992px*/
@media screen and (min-width: 992px) {
  .desktopTitle {
    background: #ffffff;
  }

  #columnLeft {
    padding-right: 10px;
  }

  #columnRight {
    padding-left: 0px;
  }

  #desktopJobPage {
    display: block;
  }
}

/* =< 991 */
@media screen and (max-width: 991px) {
  #mobileJobPage {
    display: block;
  }
}
</style>